import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Plus, X } from "lucide-react";
import { useState } from "react";
import { useLocation } from "react-router-dom";

export default function FAQ() {
  const location = useLocation();
  const isLivePage = location.pathname.includes("/live");
  const accentColor = isLivePage ? "#9146FF" : "#FF6B35";

  const defaultFaqs = [
    {
      id: "item-1",
      question: "Will I lose ownership of my content?",
      answer:
        "Absolutely not. You simply give us legal permission to perform our services by signing our copyright clearance form. That's the only rights we need - you maintain full ownership.",
      isExpanded: true,
    },
    {
      id: "item-2",
      question: "Does CreatorShield cost anything?",
      answer:
        "CreatorShield is completely free to use and costs you $0.00. We never invoice you or ask for credit card information. Our unique business model means we only collect a percentage of the proceeds we recoup for you.",
      isExpanded: true,
    },
    {
      id: "item-3",
      question: "How do I get started?",
      answer:
        "Simply navigate to our onboarding page and fill out the account activation form. It takes less than 60 seconds. We just need legal permission to perform our services, and our onboarding covers everything.",
      isExpanded: true,
    },
    {
      id: "item-4",
      question: "Can I exempt my friends from being claimed?",
      answer:
        "Absolutely! We offer a whitelist tool that lets you add channel URLs for people you don't want to claim against. Perfect for collaborators and friends.",
      isExpanded: true,
    },
  ];

  const liveFaqs = [
    {
      id: "item-1",
      question: "I'm a gamer, will this work?",
      answer:
        "If you stream with a face-cam, we can find reuploads with that segment and claim the match. We cannot copyright claim gameplay footage reuploads because we don't have exclusive rights to gaming content portions.",
      isExpanded: true,
    },
    {
      id: "item-2",
      question: "Will I lose ownership of my content?",
      answer:
        "Absolutely not. You simply give us legal permission to perform our services by signing our copyright clearance form. That's the only rights we need - you maintain full ownership.",
      isExpanded: true,
    },
    {
      id: "item-3",
      question: "Does CreatorShield LIVE cost anything?",
      answer:
        "CreatorShield is completely free to use. We never invoice you or ask for payment. Our unique business model means we only collect a percentage of the proceeds we recoup for you.",
      isExpanded: false,
    },
    {
      id: "item-4",
      question: "How do I get started?",
      answer:
        "Simply navigate to our onboarding page and fill out the account activation form. It takes less than 60 seconds. We just need legal permission to perform our services.",
      isExpanded: false,
    },
    {
      id: "item-5",
      question: "How do I not claim an authorized uploader?",
      answer:
        "We offer a whitelist tool so you can add channel URLs for people you don't want to claim against. Adding or removing channels is simple and instant.",
      isExpanded: false,
    },
  ];

  const faqs = isLivePage ? liveFaqs : defaultFaqs;
  
  const [expandedItems, setExpandedItems] = useState(faqs.length > 0 ? [faqs[0].id] : []);

  return (
    <div className="bg-white py-20 px-6 md:px-16">
      <div className="4xl:max-w-[100rem] 4xl:mx-auto">
        <div className="text-center mb-12 space-y-7">
          <p
            className="font-semibold text-lg uppercase tracking-wide"
            style={{ color: accentColor }}
          >
            QUESTIONS
          </p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-gray-900">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="max-w-3xl mx-auto">
          <Accordion
            type="multiple"
            value={expandedItems}
            onValueChange={setExpandedItems}
            className="flex flex-col gap-[25px]"
          >
            {faqs.map((faq, index) => {
              const gapClass = isLivePage
                ? index < 2
                  ? "gap-[25px]"
                  : "gap-[20px]"
                : index < 2
                  ? "gap-[25px]"
                  : "gap-[20px]";
              const isExpanded = expandedItems.includes(faq.id);
              return (
                <AccordionItem
                  key={faq.id}
                  value={faq.id}
                  className={`bg-white border-[#ddd] border-[0.5px] border-solid rounded-[20px] px-[24px] py-[23px] overflow-clip flex flex-col ${gapClass} last:!border-b-[0.5px]`}
                >
                  <AccordionTrigger className="hover:no-underline text-left [&>svg]:hidden flex items-center justify-between w-full">
                    <span className="font-semibold text-xl text-black lg:text-nowrap">
                      {faq.question}
                    </span>
                    <div className="shrink-0 w-6 h-6 flex items-center justify-center">
                      {isExpanded ? (
                        <X size={20} style={{ color: accentColor }} />
                      ) : (
                        <Plus size={20} style={{ color: accentColor }} />
                      )}
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="text-black opacity-50 text-base font-normal leading-normal pt-0">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              );
            })}
          </Accordion>
        </div>
      </div>
    </div>
  );
}
